/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DeploymentSummary,
  DeploymentSummary$inboundSchema,
} from "./deploymentsummary.js";

export type ListDeploymentResult = {
  /**
   * A list of deployments
   */
  items: Array<DeploymentSummary>;
  /**
   * The cursor to fetch results from
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListDeploymentResult$inboundSchema: z.ZodMiniType<
  ListDeploymentResult,
  unknown
> = z.pipe(
  z.object({
    items: z.array(DeploymentSummary$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listDeploymentResultFromJSON(
  jsonString: string,
): SafeParseResult<ListDeploymentResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListDeploymentResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListDeploymentResult' from JSON`,
  );
}
